import { firstUserContent, lastUserContent } from './aetherMessageHelpers.js'
import { postAetherStream } from './aetherHttp.js'
import { ensureBackendSession, readSessionMap, writeSessionMap } from './aetherSessionStore.js'

const inFlightChats = new Map()

function shouldResetBackendSession(result) {
  if (result?.code === 'HTTP_404') return true
  if (result?.code !== 'HTTP_403') return false
  return String(result?.message || '').includes('authorization_error')
}

async function sendWithSession(sessionKey, messages, signal) {
  const sessionId = await ensureBackendSession(sessionKey, messages, signal)
  const content = lastUserContent(messages)
  const result = await postAetherStream({ sessionId, content, signal })
  if (result.ok || !shouldResetBackendSession(result)) return result

  const map = readSessionMap()
  delete map[sessionKey]
  writeSessionMap(map)
  return postAetherStream({ sessionId: await ensureBackendSession(sessionKey, messages, signal), content, signal })
}

export async function postAetherBackendChatCompletion({ messages, signal, threadId, sourceIds }) {
  try {
    if (Array.isArray(sourceIds) && sourceIds.length > 0) {
      return {
        ok: false,
        code: 'ATTACHMENTS_UNSUPPORTED',
        message: 'File attachments are only supported by the Hermes chat endpoint right now.',
      }
    }
    const content = lastUserContent(messages)
    if (!content) {
      return { ok: false, code: 'EMPTY_MESSAGE', message: 'No user message to send.' }
    }
    const sessionKey = threadId || firstUserContent(messages)
    const requestKey = `${sessionKey}\n${content}`
    if (inFlightChats.has(requestKey)) return await inFlightChats.get(requestKey)

    const promise = sendWithSession(sessionKey, messages, signal).finally(() => {
      inFlightChats.delete(requestKey)
    })
    inFlightChats.set(requestKey, promise)
    return await promise
  } catch (err) {
    if (err?.name === 'AbortError' || err?.code === 'ERR_CANCELED') {
      return { ok: false, code: 'ABORTED', message: 'Request aborted.' }
    }
    return { ok: false, code: 'NETWORK', message: err?.message || 'Could not reach Aether.' }
  }
}
